import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-2 text-xl font-bold text-gray-900 dark:text-white">
              <Shield className="h-8 w-8 text-blue-600 dark:text-blue-400" />
              <span>PrivateTools</span>
            </Link>
            <p className="mt-4 text-gray-600 dark:text-gray-400 max-w-md">
              40+ powerful online tools that process everything locally in your browser. 
              Your privacy is our priority - no uploads, no storage, no tracking.
            </p>
          </div>

          {/* Tool Categories */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider">Tools</h3>
            <ul className="mt-4 space-y-2">
              <li><Link to="/category/image" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">Image Tools</Link></li>
              <li><Link to="/category/pdf" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">PDF Tools</Link></li>
              <li><Link to="/category/text" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">Text Tools</Link></li>
              <li><Link to="/category/encryption" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">Encryption</Link></li>
              <li><Link to="/category/developer" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">Developer Tools</Link></li>
              <li><Link to="/category/converters" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">Converters</Link></li>
            </ul>
          </div>

          {/* Support & Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider">Support & Legal</h3>
            <ul className="mt-4 space-y-2">
              <li><Link to="/how-to-use" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">How to Use</Link></li>
              <li><Link to="/faq" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">FAQ</Link></li>
              <li><Link to="/contact" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">Contact</Link></li>
              <li><Link to="/privacy" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">Terms of Use</Link></li>
              <li><Link to="/about" className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400">About</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 dark:text-gray-400 text-sm">
              © 2025 PrivateTools. All rights reserved. Processing happens locally in your browser.
            </p>
            <div className="mt-4 md:mt-0">
              <div className="flex items-center space-x-2 text-sm text-green-700 dark:text-green-300">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="font-medium">100% Privacy Protected</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};